// extracted by mini-css-extract-plugin
export default {"page":"FK","freeShippingContainer":"GK","customizeContainer":"HK","customizeHeader":"IK","fadein":"JK","customizeText":"KK","hidden":"LK","productcard":"MK","accordeonscontainer":"NK","freeShipping":"OK","mainpart":"PK"};
    if(module.hot) {
      // 1726593106423
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  